
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { BabyProfileForm } from "./BabyProfileForm";
import { useState } from "react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface BabyProfileDialogProps {
  onComplete?: () => void;
}

export function BabyProfileDialog({ onComplete }: BabyProfileDialogProps) {
  const [open, setOpen] = useState(false);
  const { language } = useLanguage();

  const handleComplete = () => {
    setOpen(false);
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">{t('statistics.editBabyProfile', language)}</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('baby.profile', language)}</DialogTitle>
          <DialogDescription>
            {t('baby.profile', language)}
          </DialogDescription>
        </DialogHeader>
        <BabyProfileForm onComplete={handleComplete} />
      </DialogContent>
    </Dialog>
  );
}
